<template>
  <transition name="fade">
    <div class="hs-dialog" v-show="currentValue" :style="styleObj" @click.stop="maskClose && (showDetails = false)" v-click-outside="position === 'top' ? close : null">
      <div class="white-space" v-if="position === 'top'" :style="{height: `${positionHeight}`}"></div>
      <transition :name="position === 'top' ? 'slide-top' : (animationName || 'slide')">
        <template v-if="renderType === 'if'">
          <div class="details" v-if="showDetails" @click.self.stop="_maskClose">
            <slot></slot>
          </div>
        </template>
        <template v-else>
          <div class="details" v-show="showDetails" @click.self.stop="_maskClose">
            <slot></slot>
          </div>
        </template>
      </transition>
    </div>
  </transition>
</template>
<script type="text/ecmascript-6">
import {clickOutside} from 'common/directives/outside'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '100%'
    },
    backgroundColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.6)'
    },
    position: {
      type: String,
      default: 'bottom'
    },
    positionHeight: {
      type: [Number, String],
      default: 0
    },
    renderType: { // 针对解决hs-dialog 内使用 hs-scroll组件 下拉加载异常问题 renderType = 'if' （注释：渲染时间不同步引发的问题）
      type: String,
      default: ''
    },
    maskClose: {
      type: Boolean,
      default: true
    },
    animationName: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentValue: {
      get: function() {
        this._setShowDetails(this.value)
        return this.value
      },
      set: function(val) {
        return this.$emit('input', val)
      }
    },
    styleObj() {
      if (this.position === 'top') {
        return {height: this.height, backgroundColor: this.backgroundColor, top: this.positionHeight}
      } else {
        return {height: this.height, backgroundColor: this.backgroundColor}
      }
    }
  },
  directives: {
    clickOutside
  },
  watch: {
    showDetails(val, oldVal) {
      if (!val && oldVal) {
        setTimeout(() => {
          this.currentValue = false
        }, 400)
      }
    }
  },
  data() {
    return {
      showDetails: false
    }
  },
  methods: {
    /** 关闭 */
    close() {
      this.showDetails = false
    },
    _maskClose() {
      this.maskClose && this.close()
    },
    _setShowDetails(val) {
      setTimeout(() => {
        this.showDetails = val
      }, 100)
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.white-space
  position fixed
  width 100%
  top 0
  left 0
  z-index 99
.hs-dialog
  position absolute
  width 100%
  top 0
  left 0
  // background-color $color-black_1
  z-index 99
  overflow hidden
  >.details
    width 100%
    height 100%
    position relative
.fade-enter-active
.fade-leave-active
  transition: all 300ms ease-in-out
.fade-enter
.fade-leave-active
  opacity 0
.slide-enter-active
.slide-leave-active
  transition: all 300ms ease-in-out
.slide-enter
.slide-leave-active
  transform translateY(100%)

.slide-top-enter-active
.slide-top-leave-active
  transition: all 400ms ease-in-out
.slide-top-enter
.slide-top-leave-active
  transform translateY(-100%)

.slide-left-enter-active
.slide-left-leave-active
  transition: all 300ms ease-in-out
.slide-left-enter
.slide-left-leave-active
  transform translateX(100%)
</style>
